webpackJsonp([5],{

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0);
__webpack_require__(42);
__webpack_require__(1);
module.exports = __webpack_require__(43);


/***/ }),

/***/ 42:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

$(function () {
  $('#special-navs').on('click', '.nav', function () {
    var id = $(this).attr('data-id');
    if ($('#special-navs .nav.active').attr('data-id') === id) {
      return;
    }
    $('#special-navs .nav.active').removeClass('active');
    $(this).addClass('active');
    $('.special-wrap').hide();
    $('.special-wrap').each(function () {
      if ($(this).attr('data-id') === id) {
        $(this).show();
      }
    });
  });
});


/***/ })

},[41]);


// WEBPACK FOOTER //
// js/special7a9004.js